const StyleFieldsEncode = {
    encode : {'-webkit-text-security':'disc'},
    decode : null
  }

  export default StyleFieldsEncode;


// WEBPACK FOOTER //
// ./src/utils/StyleFieldsEncode.js